import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ISalesByCategoryApiService } from './sales-by-category-api.interface';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportSalesByCategoryQueryDto } from './dtos/export-sales-by-category.query.dto';
import { FindSalesByCategoryQueryDto } from './dtos/find-sales-by-category.query.dto';
import { FindSalesByCategoryResponseDto } from './dtos/find-sales-by-category.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByCategoryApiService implements ISalesByCategoryApiService {
  private readonly ENDPOINT = 'categories';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findSalesByCategory(
    query: FindSalesByCategoryQueryDto
  ): Promise<FindSalesByCategoryResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindSalesByCategoryResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportSalesByCategory(
    query: ExportSalesByCategoryQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
